// // import { useState } from 'react';

// // export const useFormValidation = () => {
// //     const [errors, setErrors] = useState({});

// //     const validateSection = (section, data) => {
// //         const newErrors = {};

// //         section.questions.forEach(question => {
// //             if (question.required) {
// //                 const value = data[question.id];

// //                 if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
// //                     newErrors[question.id] = 'This field is required';
// //                 }

// //                 if (question.type === 'number' && value) {
// //                     if (question.validation) {
// //                         if (question.validation.min && value < question.validation.min) {
// //                             newErrors[question.id] = `Minimum value is ${question.validation.min}`;
// //                         }
// //                         if (question.validation.max && value > question.validation.max) {
// //                             newErrors[question.id] = `Maximum value is ${question.validation.max}`;
// //                         }
// //                     }
// //                 }

// //                 if (question.type === 'textarea' && value && question.maxLength) {
// //                     if (value.length > question.maxLength) {
// //                         newErrors[question.id] = `Maximum ${question.maxLength} characters allowed`;
// //                     }
// //                 }

// //                 if (question.type === 'checkbox' && value && question.maxSelections) {
// //                     if (value.length > question.maxSelections) {
// //                         newErrors[question.id] = `Maximum ${question.maxSelections} selections allowed`;
// //                     }
// //                 }
// //             }
// //         });

// //         setErrors(newErrors);
// //         return Object.keys(newErrors).length === 0;
// //     };

// //     const clearErrors = () => setErrors({});

// //     return { errors, validateSection, clearErrors };
// // };
// import { useState } from 'react';

// export const useFormValidation = () => {
//     const [errors, setErrors] = useState({});

//     const validateField = (question, value, allData) => {
//         // Required field validation
//         if (question.required) {
//             if (!value || (typeof value === 'string' && value.trim() === '')) {
//                 return `${question.text} is required`;
//             }
//             if (Array.isArray(value) && value.length === 0) {
//                 return `${question.text} is required`;
//             }
//             if (typeof value === 'object' && !value.hasCondition) {
//                 return `${question.text} is required`;
//             }
//         }

//         // Number validation
//         if (question.type === 'number' && value) {
//             const numValue = parseFloat(value);
//             if (isNaN(numValue)) {
//                 return 'Please enter a valid number';
//             }
//             if (question.validation) {
//                 if (question.validation.min !== undefined && numValue < question.validation.min) {
//                     return `Value must be at least ${question.validation.min}`;
//                 }
//                 if (question.validation.max !== undefined && numValue > question.validation.max) {
//                     return `Value must not exceed ${question.validation.max}`;
//                 }
//             }
//         }

//         // Validation for mustBeTrue (inclusion criteria)
//         if (question.validation?.mustBeTrue && value !== 'YES') {
//             return 'This must be YES for eligibility';
//         }

//         // Validation for mustBeFalse (exclusion criteria)
//         if (question.validation?.mustBeFalse && value !== 'NO') {
//             return 'This must be NO for eligibility';
//         }

//         return null;
//     };

//     const validateQuestions = (questions, data, errors = {}) => {
//         questions.forEach((question) => {
//             const value = data[question.id];

//             // Validate current question
//             const error = validateField(question, value, data);
//             if (error) {
//                 errors[question.id] = error;
//             }

//             // Validate nested questions in groups
//             if (question.type === 'group' && question.questions) {
//                 validateQuestions(question.questions, data, errors);
//             }

//             // Validate conditional questions
//             if (question.type === 'conditional' && question.conditionalLogic) {
//                 const { condition, value: conditionValue } = question.conditionalLogic;
//                 const shouldShow = data[condition] === conditionValue;

//                 if (shouldShow && Array.isArray(question.questions)) {
//                     validateQuestions(question.questions, data, errors);
//                 }
//             }
//         });

//         return errors;
//     };

//     const validateSection = (section, data) => {
//         const newErrors = {};

//         if (section && section.questions) {
//             validateQuestions(section.questions, data, newErrors);
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const clearErrors = () => {
//         setErrors({});
//     };

//     const setFieldError = (fieldId, error) => {
//         setErrors(prev => ({
//             ...prev,
//             [fieldId]: error
//         }));
//     };

//     return {
//         errors,
//         validateSection,
//         clearErrors,
//         setFieldError
//     };
// };

import { useState } from 'react';

/**
 * Custom hook for form validation
 * Validates form sections based on question requirements and conditional logic
 */
export const useFormValidation = () => {
    const [errors, setErrors] = useState({});

    /**
     * Validates a section of the form
     * @param {Object} section - The section object containing questions
     * @param {Object} data - The form data object
     * @returns {boolean} - True if validation passes, false otherwise
     */
    const validateSection = (section, data) => {
        const newErrors = {};
        let isValid = true;

        /**
         * Recursively validates questions
         * @param {Array} questions - Array of question objects
         */
        const validateQuestions = (questions) => {
            if (!questions || !Array.isArray(questions)) return;

            questions.forEach(question => {
                // Skip section headers (non-input elements)
                if (question.type === 'section') {
                    return;
                }

                // Skip group containers (validate their nested questions instead)
                if (question.type === 'group' && question.questions) {
                    validateQuestions(question.questions);
                    return;
                }

                // Check if field should be visible based on conditionalLogic
                if (question.conditionalLogic) {
                    const { condition, value } = question.conditionalLogic;
                    const conditionValue = data[condition];

                    // If condition is not met, skip validation for this field
                    if (conditionValue !== value) {
                        return;
                    }
                }

                // Check if field is hidden and should be skipped
                if (question.hidden) {
                    // Hidden fields are only validated if they have a value (were shown at some point)
                    if (!data[question.id]) {
                        return;
                    }
                }

                // Validate required fields
                if (question.required) {
                    const fieldValue = data[question.id];

                    // Check for empty values
                    if (
                        fieldValue === undefined ||
                        fieldValue === null ||
                        fieldValue === '' ||
                        (Array.isArray(fieldValue) && fieldValue.length === 0)
                    ) {
                        newErrors[question.id] = `${question.text || question.id} is required`;
                        isValid = false;
                    }
                }

                // Validate number fields
                if (question.type === 'number' && question.validation) {
                    const value = data[question.id];

                    // Only validate if field has a value
                    if (value !== undefined && value !== null && value !== '') {
                        const numValue = Number(value);

                        if (isNaN(numValue)) {
                            newErrors[question.id] = 'Please enter a valid number';
                            isValid = false;
                        } else {
                            // Check minimum value
                            if (question.validation.min !== undefined && numValue < question.validation.min) {
                                newErrors[question.id] = `Minimum value is ${question.validation.min}`;
                                isValid = false;
                            }

                            // Check maximum value
                            if (question.validation.max !== undefined && numValue > question.validation.max) {
                                newErrors[question.id] = `Maximum value is ${question.validation.max}`;
                                isValid = false;
                            }
                        }
                    }
                }

                // Validate email fields
                if (question.type === 'email' || question.validation?.type === 'email') {
                    const value = data[question.id];

                    if (value && value !== '') {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(value)) {
                            newErrors[question.id] = 'Please enter a valid email address';
                            isValid = false;
                        }
                    }
                }

                // Validate text length constraints
                if ((question.type === 'text' || question.type === 'textarea') && question.validation) {
                    const value = data[question.id];

                    if (value && value !== '') {
                        // Check minimum length
                        if (question.validation.minLength && value.length < question.validation.minLength) {
                            newErrors[question.id] = `Minimum length is ${question.validation.minLength} characters`;
                            isValid = false;
                        }

                        // Check maximum length
                        if (question.validation.maxLength && value.length > question.validation.maxLength) {
                            newErrors[question.id] = `Maximum length is ${question.validation.maxLength} characters`;
                            isValid = false;
                        }
                    }
                }

                // Validate pattern (regex)
                if (question.validation?.pattern) {
                    const value = data[question.id];

                    if (value && value !== '') {
                        const regex = new RegExp(question.validation.pattern);
                        if (!regex.test(value)) {
                            newErrors[question.id] = question.validation.patternMessage || 'Invalid format';
                            isValid = false;
                        }
                    }
                }

                // Validate custom validation rules
                if (question.validation?.custom && typeof question.validation.custom === 'function') {
                    const customError = question.validation.custom(data[question.id], data);
                    if (customError) {
                        newErrors[question.id] = customError;
                        isValid = false;
                    }
                }

                // Validate condition_with_duration fields
                if (question.type === 'condition_with_duration') {
                    const value = data[question.id];

                    if (question.required && value) {
                        // Check if status is selected
                        if (!value.status) {
                            newErrors[question.id] = 'Please select a status';
                            isValid = false;
                        }

                        // If status is YES, check if duration is provided
                        if (value.status === 'YES') {
                            if (!value.duration || !value.duration.years) {
                                newErrors[question.id] = 'Please provide duration information';
                                isValid = false;
                            }
                        }
                    }
                }

                // Validate signature fields
                if (question.type === 'signature' && question.required) {
                    const value = data[question.id];

                    if (!value || value === '') {
                        newErrors[question.id] = 'Signature is required';
                        isValid = false;
                    }
                }

                // Validate table/conditional fields
                if (question.type === 'conditional' && question.required) {
                    const value = data[question.id];

                    // Check if conditionalLogic allows this field to be shown
                    if (question.conditionalLogic) {
                        const { condition, value: conditionValue } = question.conditionalLogic;

                        if (data[condition] === conditionValue) {
                            // Field should be shown, validate it
                            if (!value || (Array.isArray(value) && value.length === 0)) {
                                newErrors[question.id] = 'At least one entry is required';
                                isValid = false;
                            }
                        }
                    }
                }

                // Recursively validate nested questions in groups
                if (question.questions && Array.isArray(question.questions)) {
                    validateQuestions(question.questions);
                }
            });
        };

        // Start validation
        validateQuestions(section.questions);

        // Update errors state
        setErrors(newErrors);

        // Log validation results in development
        if (process.env.NODE_ENV === 'development') {
            if (!isValid) {
                console.log('Validation failed for section:', section.id);
                console.log('Errors:', newErrors);
            } else {
                console.log('Validation passed for section:', section.id);
            }
        }

        return isValid;
    };

    /**
     * Clears all errors
     */
    const clearErrors = () => {
        setErrors({});
    };

    /**
     * Clears error for a specific field
     * @param {string} fieldId - The field ID to clear error for
     */
    const clearFieldError = (fieldId) => {
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[fieldId];
            return newErrors;
        });
    };

    /**
     * Sets a custom error for a field
     * @param {string} fieldId - The field ID
     * @param {string} errorMessage - The error message
     */
    const setFieldError = (fieldId, errorMessage) => {
        setErrors(prev => ({
            ...prev,
            [fieldId]: errorMessage
        }));
    };

    return {
        errors,
        validateSection,
        clearErrors,
        clearFieldError,
        setFieldError
    };
};